import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import ServerStatusTable from "../components/ServerStatusTable";
import LeadsTable from "../components/LeadsTable";
const Leads = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div>
      <Sidebar onSidebarStateChange={handleSidebarStateChange} />
      <LeadsTable sidebarOpen={sidebarOpen} />
      
    </div>
  );
};

export default Leads;
